function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay.js');
var StunLaunchTemplate = require('./call-launch.template.js');
var CallSetting = require('../components/call-setting.js');
var SaitoLoader = require('../../../../lib/saito/ui/saito-loader/saito-loader.js');
var CallScheduleJoin = require('./call-schedule-join.js');
var SaitoScheduleWizard = require('../../../../lib/saito/ui/saito-calendar/saito-schedule-wizard.js');

/**
 *
 * This is a splash screen for initiating a Saito Video call
 *
 **/
var CallLaunch = /*#__PURE__*/function () {
  function CallLaunch(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, CallLaunch);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(app, mod);
    this.callSetting = new CallSetting(app, mod);
    //
    //this looks a lot better if it is in the dom structure
    //
    // this.loader = new SaitoLoader(app, mod, ".stunx-appspace-splash");

    //
    // close-preview-window *also* shuts down the streams in call-settings
    //
    app.connection.on('close-preview-window', function () {
      var rerender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.overlay.remove();
      if (document.querySelector('.stun-appspace')) {
        document.querySelector('.stun-appspace').remove();
      }
      if (rerender) {
        _this.render();
      }
    });
    app.connection.on('call-launch-enter-call', function () {
      _this.enterCall();
    });
  }
  return _createClass(CallLaunch, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (document.querySelector('.stun-appspace')) {
        return;
      }
      this.keys = this.app.keychain.returnKeys({
        type: 'event',
        mod: 'videocall'
      });
      var future = Date.now() + 15 * 60 * 1000;
      var past = Date.now() - 15 * 60 * 1000;
      if (this.keys.length) {
        for (var i = this.keys.length - 1; i >= 0; i--) {
          if (this.keys[i].startTime > future) {
            this.keys.splice(i, 1);
            continue;
          }
          if (this.keys[i].startTime < past) {
            this.keys.splice(i, 1);
          }
        }
      }
      if (!this.callScheduleJoin) {
        this.callScheduleJoin = new CallScheduleJoin(this.app, this.mod, this.keys);
      } else {
        this.callScheduleJoin.keys = this.keys;
      }
      if (this.container === '.saito-overlay') {
        this.overlay.show(StunLaunchTemplate(this.app, this.mod, this.keys), function () {
          //Stop the video if we close the overlay
          _this2.app.connection.emit('close-preview-window');
        });
      } else if (this.container === 'body') {
        this.app.browser.addElementToDom(StunLaunchTemplate(this.app, this.mod, this.keys));
      }

      //
      // We should be able to toggle our video/audio controls
      // Do not make it a blocking loader
      //

      this.attachEvents(this.app, this.mod);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(app, mod) {
      var _this3 = this;
      if (document.getElementById('createRoom')) {
        document.getElementById('createRoom').onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  if (_this3.mod.isRelayConnected) {
                    _context.n = 1;
                    break;
                  }
                  siteMessage('Wait for peer connection');
                  return _context.a(2);
                case 1:
                  if (_this3.mod.room_obj) {
                    _context.n = 2;
                    break;
                  }
                  _context.n = 2;
                  return _this3.mod.createRoom();
                case 2:
                  _this3.enterCall();
                case 3:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('stunx-call-settings')) {
        document.getElementById('stunx-call-settings').onclick = function (e) {
          _this3.callSetting.render();
        };
      }
      if (document.getElementById('createScheduleRoom')) {
        document.getElementById('createScheduleRoom').onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var saitoScheduleWizard;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  saitoScheduleWizard = new SaitoScheduleWizard(_this3.app, _this3.mod);
                  saitoScheduleWizard.callbackAfterSubmit = /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(utcStartTime, duration) {
                      var description,
                        title,
                        call_id,
                        room_obj,
                        call_link,
                        event_link,
                        _args2 = arguments;
                      return _regenerator().w(function (_context2) {
                        while (1) switch (_context2.n) {
                          case 0:
                            description = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
                            title = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : '';
                            _context2.n = 1;
                            return _this3.mod.generateRoomId();
                          case 1:
                            call_id = _context2.v;
                            room_obj = {
                              call_id: call_id,
                              scheduled: true,
                              call_peers: [],
                              startTime: utcStartTime,
                              duration: duration,
                              profile: {
                                description: description
                              }
                            };
                            call_link = _this3.mod.generateCallLink(room_obj);
                            _this3.app.keychain.addKey(call_id, {
                              identifier: title || 'Video Call',
                              startTime: utcStartTime,
                              duration: duration,
                              description: description,
                              link: call_link
                            });
                            _this3.app.connection.emit('close-preview-window', true); // rerender screen
                            event_link = _this3.app.browser.createEventInviteLink(_this3.app.keychain.returnKey(call_id));
                            _context2.n = 2;
                            return navigator.clipboard.writeText(event_link);
                          case 2:
                            siteMessage('Invitation link copied to clipboard', 3500);
                          case 3:
                            return _context2.a(2);
                        }
                      }, _callee2);
                    }));
                    return function (_x3, _x4) {
                      return _ref3.apply(this, arguments);
                    };
                  }();
                  saitoScheduleWizard.render();
                case 1:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
      if (document.getElementById('joinScheduleRoom')) {
        document.getElementById('joinScheduleRoom').onclick = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var s;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  s = _this3.callScheduleJoin.render();
                  if (!s) {
                    document.getElementById('createRoom').click();
                  }
                case 1:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x5) {
            return _ref4.apply(this, arguments);
          };
        }();
      }
      if (document.querySelector('.stunx-precall-link')) {
        document.querySelector('.stunx-precall-link').onclick = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
            var mode;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  mode = e.currentTarget.dataset.id;
                  if (!(mode == 'join')) {
                    _context5.n = 2;
                    break;
                  }
                  _context5.n = 1;
                  return _this3.mod.copyInviteLink();
                case 1:
                  _context5.n = 5;
                  break;
                case 2:
                  if (!(mode == 'create')) {
                    _context5.n = 4;
                    break;
                  }
                  _this3.mod.createRoom();
                  _context5.n = 3;
                  return _this3.mod.copyInviteLink();
                case 3:
                  _context5.n = 5;
                  break;
                case 4:
                  _this3.callScheduleJoin.render(false);
                  return _context5.a(2);
                case 5:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x6) {
            return _ref5.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "enterCall",
    value: function enterCall() {
      //
      // Set big screen video as desired call interface
      //

      this.app.connection.emit('stun-init-call-interface', this.callSetting.returnSettings());

      // Copy link here!
      if (this.mod.room_obj.host_public_key == this.mod.publicKey) {
        this.mod.copyInviteLink();
      }

      //
      //Close this component
      //
      this.app.connection.emit('close-preview-window');
      //
      // Start the stun call
      //
      this.app.connection.emit('start-stun-call');
    }
  }]);
}();
module.exports = CallLaunch;